
export interface IDanishCompanyIndex {
  id?: string;
  companyName?: string;
  coName?: string;
  street?: string;
  zip?: string;
  city?: string;
  placeName?: string;
  cVRNumber?: string;
  email?: string;
  phone?: string;
}
